export default function FormGroupBox({ className = "", children, ...rest }) {
  return <div className={`peb-form-box ${className}`} {...rest}>{children}</div>;
}
